// extracted by mini-css-extract-plugin
export default {"container":"Tfa-z","oos":"Ufa-z","selected":"Vfa-z"};